<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="已开户号码" name="first">
        <OpenList ></OpenList>
      </el-tab-pane>
      <el-tab-pane label="未开户号码" name="second">
        <CloseList ></CloseList>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import OpenList from "./NumberCard.vue";
import CloseList from "./CloseNumberCard.vue";
export default {
  components: {
    OpenList,
    CloseList,
  },
  data() {
    return {
      activeName: "first",
    };
  },
};
</script>

<style></style>